module.exports = __webpack_public_path__ + "static/media/airplane-icon.cb417cf4.jpg";